import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IntegrationInstructionsOutlinedIcon from "@mui/icons-material/IntegrationInstructionsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { IconTile } from "../../components/ui";
import { accentText, DirArrow, FeatureCard, PageHero, Section } from "./MarketingParts";

export default function MarketingInfo() {
  const { t } = useTranslation();

  const guides = [
    {
      icon: <IntegrationInstructionsOutlinedIcon />,
      tone: "primary",
      title: t("m_info_guide_1_title"),
      text: t("m_info_guide_1_desc"),
      to: "/install-guide",
    },
    {
      icon: <DescriptionOutlinedIcon />,
      tone: "success",
      title: t("m_info_guide_2_title"),
      text: t("m_info_guide_2_desc"),
      to: "/support",
    },
    {
      icon: <QueryStatsOutlinedIcon />,
      tone: "violet",
      title: t("m_info_guide_3_title"),
      text: t("m_info_guide_3_desc"),
      to: "/pricing",
    },
  ];

  return (
    <>
      <PageHero eyebrow={t("mk_info_eyebrow")} icon={<MenuBookOutlinedIcon sx={{ fontSize: 16 }} aria-hidden="true" />} title={t("m_info_title")} subtitle={t("m_info_subtitle")} />

      <Section sx={{ pt: { xs: 5, md: 7 } }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: { xs: 2.5, md: 3 } }}>
          {guides.map((g) => (
            <FeatureCard key={g.title} component="article" interactive>
              <IconTile size={44} tone={g.tone} sx={{ mb: 2.5 }}>
                {g.icon}
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.15rem", mb: 1 }}>
                {g.title}
              </Typography>
              <Typography sx={{ color: "text.secondary", lineHeight: 1.7, mb: 2.5 }}>{g.text}</Typography>
              <Box sx={{ mt: "auto" }}>
                <Button component={RouterLink} to={g.to} endIcon={<DirArrow />} sx={{ px: 1, ml: -1, color: accentText }}>
                  {t("m_info_read_more")}
                  <Box component="span" sx={{ position: "absolute", width: "1px", height: "1px", overflow: "hidden", clip: "rect(0 0 0 0)" }}>
                    {`: ${g.title}`}
                  </Box>
                </Button>
              </Box>
            </FeatureCard>
          ))}
        </Box>
      </Section>
    </>
  );
}
